import type { Content } from '@prismicio/client';

export { ContentMarqueeCarousel } from './ContentMarqueeCarousel';
export type { ContentMarqueeCarouselComponentProps } from './ContentMarqueeCarousel';
export type ContentMarqueeCarouselSlice = Content.ContentMarqueeCarouselSlice;
export type ContentMarqueeCarouselSliceDefault =
  Content.ContentMarqueeCarouselSliceDefault;
export type ContentMarqueeCarouselSliceDefaultItem =
  Content.ContentMarqueeCarouselSliceDefaultItem;
export type ContentMarqueeCarouselSliceDefaultPrimary =
  Content.ContentMarqueeCarouselSliceDefaultPrimary;
